import { Container, Stack, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { API_URL } from "./Constants";
import { AutoSignupCard } from "./AutoSignupCard";
import Copyright from "./Copyright";
import { DiscordSignIn } from "./DiscordSignIn";
import { Hero } from "./Hero";
import { Loading } from "./Loading";
import { DisconnectCard } from "./DisconnectCard";
import { Manage } from "./Manage";
import { ReminderCard } from "./ReminderCard";
import { VoloConnect } from "./VoloConnect";

const VoloPilot = () => {
  return (
    <Container component="main" maxWidth="sm" sx={{ pb: 4 }}>
      <Dashboard />
      <Copyright />
    </Container>
  );
};

const Dashboard = () => {
  const {
    isPending,
    error,
    data: status,
    refetch,
  } = useQuery({
    queryKey: ["status"],
    queryFn: () =>
      fetch(API_URL + "/status", { credentials: "include" }).then((res) =>
        res.json()
      ),
  });

  if (isPending) {
    return <Loading />;
  }

  if (!status?.loggedIn || error) {
    return (
      <>
        <Hero tagline="Volo pickups & calendar, on autopilot." />
        <DiscordSignIn subtitle="Sign in with Discord to put your Volo games on your calendar and get auto-signed-up for new pickups." />
      </>
    );
  }

  // One Volo connection powers both features; connect once, then use them.
  if (!status.voloId) {
    return (
      <>
        <Hero />
        <VoloConnect refetchLoginStatus={refetch} />
      </>
    );
  }

  return (
    <>
      <Hero />
      <Stack direction="column" spacing={2.5} marginTop={2}>
        <AutoSignupCard
          consented={!!status.consented}
          paused={!!status.paused}
          pausedUntil={status.pausedUntil ?? null}
          hasVoloPass={!!status.hasVoloPass}
          signupDays={status.signupDays ?? null}
          filters={{
            neighborhoods: status.signupNeighborhoods ?? null,
            levels: status.signupLevels ?? null,
            earliest: status.signupEarliest ?? null,
            latest: status.signupLatest ?? null,
          }}
          neighborhoodOptions={status.neighborhoodOptions ?? []}
          refetch={refetch}
        />
        <ReminderCard
          dailyReminder={status.dailyReminder !== false}
          refetch={refetch}
        />
        <Manage volocalToken={status.volocalToken} />
        <DisconnectCard refetch={refetch} />
      </Stack>
    </>
  );
};

export default VoloPilot;
